(function() {
    angular.module('emarket.main.profile').factory('Chat', ['$http', 'PATH', 'restmod', function($http, PATH, restmod) {
        var Chat = restmod.model('/chat').mix({
            messages: {
                hasMany: 'ChatMessage',
                path: 'messages'
            }
        });
        Chat.getMessages = function(id) {
            var url = PATH.api + '/chat/' + id + '/messages';
            return $http.get(url).then(function(response) {
                return response.data;
            });
        };
        Chat.sendMessage = function(id, message) {
            var url = PATH.api + '/chat/' + id + '/messages';
            return $http.post(url, { message: message }).then(function(response) {
                return response.data;
            });
        };

        Chat.events = {
            ON_SELECT_CHAT: 'chat_on_select_chat'
        };
        Chat.getUnreadMessageCount = function() {
            var url = PATH.api + '/chat/unread';
            return $http.get(url).then(function(response) {
                return response.data;
            });
        };
        return Chat;
    }]);
}());
